import zeroPad from './zero-pad';

export default function formatTimeSpent(value?: number | null): string | null {
  if (!value) return null;
  const h = Math.floor(Math.abs(value / 60));
  const m = Math.abs(value % 60);
  return value < 60 ? `${m}m` : `${h}h${zeroPad(m)}m`;
}
